"use client";
import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

type BoxContentProps = {
  title: string;
  para: string;
};

gsap.registerPlugin(ScrollTrigger);

export default function BoxContent({ title, para }: BoxContentProps) {
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: boxRef.current,
        start: "top 75%",
        toggleActions: "play reverse play reverse",
      },
    });

    tl.to(boxRef.current, { opacity: 1, y: 0, duration: 0.85 });

    return () => {
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
    };
  }, []);

  return (
    <div
      className="text-center px-6 py-8 rounded-2xl bg-gradient-to-b from-white to-transparent w-full mb-7 opacity-0 translate-y-9"
      ref={boxRef}
    >
      <h3>{title}</h3>
      <p className="text-body-small-fontsize font-semibold text-midGrey2 mb-0">
        {para}
      </p>
    </div>
  );
}
